import { useState } from 'react';
import {
    guardarHistorialDeEmpleado,
    obtenerDocumentosPorEmpleado,
    eliminarDocumento,
    getDocumentoCabByEmpleadoYTipo,
    guardarDocumentosCab,
    modificarDocumentosCab,
    anulaDocumentoCab
} from '../../../services/empleado/empleadoDocumentoService';
import { formatToJava } from '../../../util/dateUtils';

const emptyHistorial = {
    id: null,
    tipo: null,
    numero: '',
    observaciones: '',
    fechaEmision: null,
    fecha_inicio: null,
    fecha_fin: null,
    tipoId: null
};

// Helper de fechas
const convertirFecha = (f) => {
    if (!f) return null;
    if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
    if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
    if (typeof f === 'string') return new Date(f);
    return new Date(f);
};

export const useHistorial = ({ empleadoId, toast, configMap, listas }) => {
    // 1. Estados
    const [historialList, setHistorialList] = useState([]);
    const [historialData, setHistorialData] = useState(emptyHistorial);
    const [historialDialog, setHistorialDialog] = useState(false); // Modal del Formulario
    const [historialFile, setHistorialFile] = useState([]);

    const [loading, setLoading] = useState(false);

    const [grabaHistorial, setGrabaHistorial] = useState(false);
    // 2. Carga de Historial
    const recargarHistorial = async (id) => {
        if (!id) {
            setHistorialList([]);
            return;
        }

        try {
            const docs = await obtenerDocumentosPorEmpleado(id);

            // A. Obtener IDs válidos de categorías de historial (Sanción, Felicitación, etc.)
            // Estos vienen del catálogo 'NOM-0000-0010'
            const idsCategoriasHistorial =
                listas?.tiposHistorial?.map((t) => t.configuracionDetId) || [];

            // B. Filtrado
            const misHist = docs.filter((d) => {
                // Validación 1: ¿Tiene una categoría que pertenezca a la lista de historial?
                if (d.categoriaId && idsCategoriasHistorial.includes(parseInt(d.categoriaId))) {
                    return true;
                }

                // Validación 2 (Respaldo): Por ID de Tipo Documento específico
                const configHist = listas?.tiposOtrosDocs?.find(
                    (x) => x.codigo === configMap.FORM_HISTORIAL
                );
                const ID_FORM_HISTORIAL = configHist ? configHist.configuracionDetId : null;

                if (ID_FORM_HISTORIAL && d.tipoDocumentoId === ID_FORM_HISTORIAL) {
                    return true;
                }
                return false;
            });

            // C. Mapeo
            setHistorialList(
                misHist.map((doc) => ({
                    // Usar el ID que venga del servidor (id o documentoId)
                    id: doc.id || doc.documentoId,
                    tipo: doc.categoriaId,
                    numero: doc.referencia,
                    observaciones: doc.descripcion,
                    // Sincronizar con el nombre exacto que vimos en tu consola
                    fechaEmision: convertirFecha(doc.fechaEmision || doc.fechaEmision),
                    fecha_inicio: convertirFecha(doc.fechaInicio || doc.fecha_inicio),
                    fecha_fin: convertirFecha(doc.fechaFin || doc.fecha_fin),
                    archivoUrl: doc.url
                }))
            );
        } catch (e) {
            console.error('Error recargando historial:', e);
        }
    };

    // 3. Acciones del Modal
    const openNewHistorial = () => {
        setHistorialData({ ...emptyHistorial, fechaEmision: new Date() });
        setHistorialFile(null);
        setHistorialDialog(true);
    };

    const openEditHistorial = (rowData) => {
        setHistorialData({ ...rowData });
        setHistorialFile(null);
        setHistorialDialog(true);
    };

    // 4. Guardar
    const saveHistorial = async () => {
        if (loading) return;
        if (!empleadoId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Guarde el empleado primero.'
            });
            return;
        }

        if (!historialData.tipo || (!historialData.id && !historialFile)) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Tipo y Archivo son obligatorios para registros nuevos.'
            });
            return;
        }

        const formatearFecha = (d) => (d && d.toISOString ? d.toISOString().split('T')[0] : null);

        const payload = {
            id: historialData.id,
            codigoTipoDocumento: configMap.FORM_HISTORIAL,
            categoriaId: historialData.tipo,
            referenciaDetalle: historialData.numero,
            descripcion: historialData.observaciones,
            fechaEmision: formatearFecha(historialData.fechaEmision),
            fecha_inicio: formatearFecha(historialData.fecha_inicio),
            fecha_fin: formatearFecha(historialData.fecha_fin)
        };

        try {
            setLoading(true);
            await guardarHistorialDeEmpleado(empleadoId, payload, historialFile);
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Historial registrado.'
            });

            setHistorialDialog(false);
            setHistorialData(emptyHistorial);
            setHistorialFile(null);

            await recargarHistorial(empleadoId);
        } catch (e) {
            console.error(e);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo guardar.'
            });
        } finally {
            setLoading(false);
        }
    };

    // 5. Eliminar
    const deleteHistorial = async (rowData) => {
        if (!window.confirm(`¿Eliminar historial ${rowData.numero || ''}?`)) return;

        try {
            await eliminarDocumento(rowData.id);
            toast.current.show({
                severity: 'success',
                summary: 'Eliminado',
                detail: 'Historial eliminado.'
            });
            setHistorialList((prev) => prev.filter((item) => item.id !== rowData.id));
        } catch (error) {
            console.error('Error al eliminar historial:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar.'
            });
        }
    };

    //***********  cambios HISTORIAL BEGIN
    const cargaHistorial = async (empleadoId) => {
        const CODE_TIPOREGISTRO_HISTORIAL = 'NOM-0000-0015-0003';
        try {
            const data = await getDocumentoCabByEmpleadoYTipo(
                empleadoId,
                CODE_TIPOREGISTRO_HISTORIAL
            );
            const lista = data.map((item) => ({
                id: item.documentoCabId,
                tipo: item.categoriaConfDet.configuracionDetId,
                numero: item.referenciaDetalle,
                observaciones: item.descripcion,
                fechaEmision: convertirFecha(item.fechaEmision),
                fecha_Inicio: convertirFecha(item.fechaInicio),
                fecha_fin: convertirFecha(item.fechaFin),
                archivoUrl: ''
            }));

            setHistorialList(lista);
        } catch (error) {
            console.error('Error al Obtener Licencias:', error);
        }
    };

    const guardaHistorial = async () => {
        if (loading) return;
        if (!empleadoId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Guarde el empleado primero.'
            });
            return;
        }

        if (!historialData.tipoId || (!historialData.id && !historialFile)) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Tipo y Archivo son obligatorios para registros nuevos.'
            });
            return;
        }

        const CODE_TIPOREGISTRO_HISTORIAL = 'NOM-0000-0015-0003';
        setGrabaHistorial(true)
        try {
            const objGuardar = {
                entidadId: empleadoId,
                nombreEntidad: 'EMPLEADO',
                categoriaConfDetId: historialData.tipoId,
                referenciaDetalle: historialData.numero,
                descripcion: historialData.observaciones,
                fechaEmision: formatToJava(historialData.fechaEmision),
                fechaInicio: formatToJava(historialData.fecha_inicio),
                fechaFin: formatToJava(historialData.fecha_fin),
                codigoTipoDocumento: CODE_TIPOREGISTRO_HISTORIAL
            };
            if (historialData.id) {
                objGuardar['documentoCabId'] = historialData.id;
                console.log('CELULAR II..: ', objGuardar);
                const data = await modificarDocumentosCab(objGuardar, historialFile);
            } else {
                const data = await guardarDocumentosCab(objGuardar, historialFile);
            }

            setHistorialDialog(false);
            setHistorialData(emptyHistorial);
            setHistorialFile(null);

            await cargaHistorial(empleadoId);
        } catch (error) {
            console.error('Error al Guardar Historial:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se han guardado las Licencias'
            });
        } finally {
            setGrabaHistorial(false)
        }
    };

    const anulaHistorial =async(rowData)=>{
        if (!window.confirm(`¿Eliminar historial ${rowData.numero || ''}?`)) return;

        try {
                    const data = await anulaDocumentoCab(rowData.id);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Eliminado',
                        detail: 'Licencia eliminada.'
                    });
        
                    // Actualización optimista o recarga
                    setHistorialList((prev) => prev.filter((item) => item.id !== rowData.id));
                } catch (error) {
                    console.error('Error eliminando licencia:', error);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No se pudo eliminar.'
                    });
                }
    }

    //***********  cambios HISTORIAL END

    return {
        historialList,
        historialData,
        setHistorialData,
        historialDialog,
        setHistorialDialog,
        historialFile,
        setHistorialFile,
        recargarHistorial,
        openNewHistorial,
        openEditHistorial,
        saveHistorial,
        deleteHistorial,
        setHistorialList,
        loading,
        cargaHistorial,
        guardaHistorial,
        grabaHistorial,
        anulaHistorial
    };
};
